export default {
  path: '/home/trade-whitelist',
  component: () => import('./index.vue'),
  // children: [
  //   { 
  //     path: 'edit',
  //     name: 'WhitelistEdit',
  //     component: () => import('./components/update/index.vue'),
  //     props: (route) => ({ item: route.query.item })
  //   }
  // ]
};